import Rewards from './Rewards';
import { connect } from 'react-redux';
import { getOffers, postLeakRepairSignup } from '../../actions/challenges';
import { setMeta } from '../../actions';

import { AppState } from '../../interfaces';
const mapStateToProps = (state: AppState) => ({
  challenges: state.challengesReducer,
  listLocation: state.listLocationReducer,
  leakFixSignup: state.challengesReducer.leakFixSignup,
  user: state.preferencesReducer,
});
const mapDispatchToProps = (dispatch) => ({
  getOffers: (id) => dispatch(getOffers(id)),
  postLeakRepairSignup: (data, taskTag, taskId, propertyId, onSuccess) =>
    dispatch(
      postLeakRepairSignup(data, taskTag, taskId, propertyId, onSuccess)
    ),
  setMeta: (propertyId) => dispatch(setMeta(propertyId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Rewards);
